import { render } from "./suc.vue?vue&type=template&id=0c7cef82&scoped=true"
const script = {}

import "./suc.vue?vue&type=style&index=0&id=0c7cef82&lang=scss&scoped=true"

import exportComponent from "D:\\六问前端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7cef82"]])

export default __exports__